import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unused2",
  "use": "icon-unused2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-unused2\"><defs><style>#icon-unused2 .cls-1{ }</style></defs><title>统计报表</title><path class=\"cls-1\" d=\"M7.68,14.28A6.68,6.68,0,0,0,14.36,7.6H8.15a.45.45,0,0,1-.33-.14.44.44,0,0,1-.14-.33V.92a6.68,6.68,0,0,0,0,13.36Zm0,0\" /><path class=\"cls-1\" d=\"M15,6.33A6.05,6.05,0,0,0,9,.28V6a.34.34,0,0,0,.32.32Zm0,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol